"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _S3Plugin = /*#__PURE__*/ _interop_require_default(require("./S3Plugin"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const config = {
    builder: _S3Plugin.default,
    id: 'aws-s3',
    title: 'S3',
    version: '0.0.6',
    logo: 'plugins/s3.png',
    description: 'Amazon Simple Storage Service (Amazon S3) is an object storage service that offers industry-leading scalability, data availability, security, and performance.',
    inputs: {
        title: 'Configure Amazon S3',
        items: [
            {
                key: 'bucket',
                label: 'Bucket Name',
                placeholder: 'Bucket Name',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'region',
                label: 'Region',
                placeholder: 'Region',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'endpoint',
                label: 'Endpoint',
                placeholder: 'Endpoint',
                type: _nocodbsdk.XcType.SingleLineText,
                required: false
            },
            {
                key: 'access_key',
                label: 'Access Key',
                placeholder: 'Access Key',
                type: _nocodbsdk.XcType.SingleLineText,
                required: false
            },
            {
                key: 'access_secret',
                label: 'Access Secret',
                placeholder: 'Access Secret',
                type: _nocodbsdk.XcType.Password,
                required: false
            },
            {
                key: 'acl',
                label: 'Access Control Lists (ACL)',
                placeholder: '',
                type: _nocodbsdk.XcType.SingleLineText,
                required: false
            },
            {
                key: 'force_path_style',
                label: 'Force Path Style',
                placeholder: 'Default set to false',
                type: _nocodbsdk.XcType.Checkbox,
                required: false
            }
        ],
        actions: [
            {
                label: 'Test',
                placeholder: 'Test',
                key: 'test',
                actionType: _nocodbsdk.XcActionType.TEST,
                type: _nocodbsdk.XcType.Button
            },
            {
                label: 'Save',
                placeholder: 'Save',
                key: 'save',
                actionType: _nocodbsdk.XcActionType.SUBMIT,
                type: _nocodbsdk.XcType.Button
            }
        ],
        msgOnInstall: 'Successfully configured! Attachments will now be stored in AWS S3.',
        msgOnUninstall: ''
    },
    category: _nocodbsdk.PluginCategory.STORAGE,
    tags: 'Storage'
};
const _default = config;
